import actions from "./actions";

const { FETCH_PRESCHOOL, FETCH_PRESCHOOL_ATTENDANCE } = actions;

const initState = {
    preschool: [],
    preschoolAttendance: [],
};

const PreschoolReducer = (state = initState, action) => {
    const { type, data } = action;
    switch (type) {
        case FETCH_PRESCHOOL:
            return {
                ...state,
                preschool: data
            };
        case FETCH_PRESCHOOL_ATTENDANCE:
            return {
                ...state,
                preschoolAttendance: data
            };
        default:
            return state;
    }
};

export default PreschoolReducer;